import teacherService from 'ApiService/Admin/teacherService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useFormKeyboardSubmit } from 'pages/Hooks/useStepperKeyboardNavigation';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import TeacherInfo from './Steps/TeacherInfo';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [teacherData, setTeacherData] = useState({
    teacherName: '',
    teacherEmail: '',
    teacherPassword: '',
    contactNumber: '',
    department: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const router = useNavigate();
  const { state } = useContext(AuthContext);
  const selectedBranch = state?.selectedBranch || '';

  const handleSubmit = async () => {
    if (
      teacherData.teacherName &&
      teacherData.teacherEmail &&
      teacherData.teacherPassword &&
      teacherData.contactNumber &&
      teacherData.department
    ) {
    } else {
      toast.error('All fields are required.');
    }
    setIsModalOpen(true);
  };

  const confirmCreation = async () => {
    setIsModalOpen(false);
    setLoading(true);
    try {
      const trimmedData = {
        teacherName: teacherData.teacherName?.trim().replace(/\s+/g, ' '),
        teacherEmail: teacherData.teacherEmail?.trim().replace(/\s+/g, ' '),
        teacherPassword: teacherData.teacherPassword
          ?.trim()
          .replace(/\s+/g, ' '),
        contactNumber: teacherData.contactNumber?.trim().replace(/\s+/g, ' '),
        department: teacherData.department,
      };
      const response = await teacherService.createTeacher({
        ...trimmedData,
        selectedBranch,
      });
      if (response.data.success) {
        setTeacherData({
          teacherName: '',
          teacherEmail: '',
          teacherPassword: '',
          contactNumber: '',
          department: '',
        });
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useFormKeyboardSubmit(handleSubmit, disable, loading);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card
          extra={
            ' -mt-[280px] w-full md:-mt-[240px] md:px-[70px] h-full mx-auto pb-3'
          }
        >
          <div className="rounded-[20px]">
            <UseContextProvider>
              <TeacherInfo
                setTeacherData={setTeacherData}
                teacherData={teacherData}
                disable={disable}
                setDisable={setDisable}
              />
            </UseContextProvider>
          </div>
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              disabled={disable}
              onClick={handleSubmit}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
            >
              {loading ? 'Loading..' : 'Submit'}
            </button>
          </div>
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Create Teacher Confirmation"
        message={`Are you sure you want to create ${teacherData.teacherName} as an teacher user?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
